export default (input_color_vec3: string, input_diffuse_float: string, input_spec_float: string, output_vec3: string) => {
	return `
	vec3 _toonColor = ${input_color_vec3};

	
	if (${input_diffuse_float} > 0.6) {
		float quantized = 8.0;
		_toonColor = _toonColor * quantized;
		_toonColor = ceil(_toonColor);
		_toonColor = _toonColor / quantized;
	} else {
		if (${input_diffuse_float} > 0.2) {
			_toonColor =  _toonColor;
		} else if (${input_diffuse_float} > 0.01) {
			_toonColor = 0.8 * _toonColor;
		} else {
			_toonColor = 0.5 * _toonColor;
		}
	}


	// if(${input_spec_float} > 0.1) {
	// 	_toonColor = 1.0 * _toonColor; 
	// }
	// else {
	// 	if (${input_diffuse_float} > 0.7)
	// 		_toonColor = 1.0 * _toonColor;
	// 	if (${input_diffuse_float} > 0.95)
	// 		_toonColor = 1.0 * _toonColor;
	// 	else if (${input_diffuse_float} > 0.5)
	// 		_toonColor = 0.7 * _toonColor;
	// 	else if (${input_diffuse_float} > 0.2)
	// 		_toonColor = 0.5 * _toonColor;
	// 	else
	// 		_toonColor = 0.2 * _toonColor;

	// if (${input_diffuse_float} > 0.2)
	// 	_toonColor = 1.0 * _toonColor;
	// else if (${input_diffuse_float} > 0.01)
	// 	_toonColor = 0.8 * _toonColor;
	// else
	// 	_toonColor = 0.5 * _toonColor;

	//}

	${output_vec3} = _toonColor;
	`
}